import { motion } from "framer-motion";
import { MessageCircle, ArrowRight } from "lucide-react";
import { waLink, HERO_IMAGE } from "@/lib/site";

export const Hero = () => {
  return (
    <section id="top" className="relative overflow-hidden pt-28 pb-16 lg:pt-36 lg:pb-24 bg-white">
      {/* background outline word */}
      <div className="pointer-events-none absolute -top-6 left-0 right-0 overflow-hidden opacity-[0.04]">
        <p className="font-display font-bold text-[22vw] leading-none tracking-tighter text-brand-navy whitespace-nowrap">
          SOURCING
        </p>
      </div>

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-10 lg:gap-8 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-brand-red mb-5">
            Chine · Corée · Livraison dans le monde entier
          </p>
          <h1 className="font-display font-bold uppercase tracking-tighter leading-[0.92] text-brand-navy text-4xl sm:text-6xl lg:text-7xl">
            Votre pont direct
            <br />
            vers <span className="text-brand-red">l'Asie</span>
          </h1>
          <p className="mt-6 max-w-xl text-base lg:text-lg text-slate-600 leading-relaxed">
            Je source, je négocie et j'achète pour vous en Chine et en Corée, puis
            je <strong className="text-brand-navy">livre partout dans le monde</strong>.
            King of Sourcing connecte n'importe quel pays aux meilleurs fournisseurs chinois et coréens —
            pour les entreprises comme pour les particuliers.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-4">
            <a
              href="#devis"
              data-testid="hero-quote-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-navy px-7 py-3.5 text-sm font-bold uppercase tracking-wide text-white hover:-translate-y-1 transition-transform duration-300"
            >
              Demander un devis <ArrowRight size={18} />
            </a>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-whatsapp px-7 py-3.5 text-sm font-bold uppercase tracking-wide text-white hover:-translate-y-1 transition-transform duration-300"
            >
              <MessageCircle size={18} /> Discuter maintenant
            </a>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
            {[
              { k: "500+", v: "Fournisseurs vérifiés" },
              { k: "1000+", v: "Clients satisfaits" },
              { k: "Années", v: "d'expérience" },
            ].map((s) => (
              <div key={s.v}>
                <p className="font-display font-bold text-2xl text-brand-navy">{s.k}</p>
                <p className="text-xs text-slate-500 mt-1">{s.v}</p>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.15, ease: "easeOut" }}
          className="relative"
        >
          <div className="absolute -inset-3 bg-brand-gold/10 rounded-xl -rotate-2" />
          <img
            src={HERO_IMAGE}
            alt="King of Sourcing — achat et livraison depuis la Chine et la Corée"
            data-testid="hero-image"
            className="relative w-full rounded-lg shadow-2xl object-cover"
          />
        </motion.div>
      </div>
    </section>
  );
};
